import modal from '@/js/utils/modal';
const blockFreshCycle = function() {
  if ($('.block-fresh-cycle').length === 0) return;
  const modalEl = modal('fresh-cycle-modal');
  $('.fresh-cycle-modal .tingle-modal__close').detach().prependTo('.fresh-cycle-modal .tingle-modal-box');
  $('.js-learn-more').on('click', (e) => {
    const currentTargetDataTrigger = e.currentTarget?.dataset?.trigger || '';
    if(currentTargetDataTrigger) {
      modalEl.setContent(document.querySelector(`[data-content="${currentTargetDataTrigger}"]`).innerHTML);
      bindClickEvents();
      modalEl.open();
    }
  })

  function bindClickEvents() {
    //binding footer ctas after copying content to a modal
    $(document).on('click touchend', '.prev-step, .next-step', (e) => {
      const currentTargetDataTrigger = e.currentTarget?.dataset?.goto || '';
      if(currentTargetDataTrigger) {
        modalEl.close();
        modalEl.setContent(document.querySelector(`[data-content="${currentTargetDataTrigger}"]`).innerHTML);
        modalEl.open();
      }
    });
  }
};

export default blockFreshCycle;
